// extracted by mini-css-extract-plugin
export var pillWrapper = "_y4-0";
export var showOverflow = "_y4-1";